<mat-chip-list class="group-chip-list">
  <mat-chip
    data-id="GroupDropdown.Group"
    *ngIf="!groupSelected"
    (click)="groupSelected = !groupSelected"
    [color]="'primary'"
  >
    <img
      [src]="'../../assets/images/group_white.svg'"
      class="group-img"
      alt="Group Selected Students"
    />
    <span class="group-chip-text">GROUP</span>
  </mat-chip>
  <mat-chip
    data-id="GroupDropdown.Cancel"
    *ngIf="groupSelected"
    (click)="groupSelected = !groupSelected"
    [color]="'accent'"
  >
    <img
      [src]="'../../assets/images/x_icon.svg'"
      class="group-img"
      alt="Cancel"
    />
    <span class="group-chip-text">CANCEL</span>
  </mat-chip>
</mat-chip-list>
<div class="chip-div" *ngIf="groupSelected">
  <mat-chip-list class="group-chip-list" (clickOutside)="groupSelected = false">
    <mat-chip
      data-id="GroupDropdown.New"
      (click)="this.addGroupClicked.emit(); groupSelected = false"
      [color]="'secondary'"
    >
      <img
        [src]="'../../assets/images/group_green.svg'"
        class="group-img"
        alt="New Group"
      />
      <span class="group-chip-text">Create New Group</span>
    </mat-chip>
    <mat-chip
      data-id="GroupDropdown.Add"
      (click)="this.addStudentsToGroupClicked.emit(); groupSelected = false"
      [color]="'secondary'"
    >
      <img
        [src]="'../../assets/images/group_add_green.svg'"
        class="group-img"
        alt="Add to Group"
      />
      <span class="group-chip-text">Add to Group</span>
    </mat-chip>
    <mat-chip
      data-id="GroupDropdown.Remove"
      (click)="
        this.removeStudentsFromGroupClicked.emit(); groupSelected = false
      "
      [color]="'secondary'"
    >
      <img
        [src]="'../../assets/images/group_remove_green.svg'"
        class="group-img"
        alt="Remove from Group"
      />
      <span class="group-chip-text">Remove from Group</span>
    </mat-chip>
  </mat-chip-list>
</div>
